export var CORPORATE_PARTNER_STORAGE_KEY = 'cpCorporatePartner';
export var CORPORATE_PARTNER_JUSTWORKS = 'justworks';
export var CORPORATE_JUSTWORKS_REGEX = /^USA_\w*_JUSTWORKS\d*CREDITCORPORATEPLAN\d*_\d*_\d*_\w*_\d*CREDIT$/;
export var CORPORATE_PLAN_REGEX = /^[A-Z]{3}_[A-Z]+_[A-Z0-9]+CORPORATE[A-Z]*PLAN.*_\d+_[0-9]+X_[0-9]+CREDIT$/;